<template>
    <v-form ref="form" data-cy="settings-form">
        <v-row>
            <v-col cols="12" lg="6">
                <h4 class="text-h6 text-capitalize pb-2">
                    {{ $t('clients_page.email_preferences') }}
                </h4>
                <v-row dense>
                    <v-checkbox
                        v-model="settings.receiveMarketingEmails"
                        :label="$t('clients_page.receive_marketing_emails')"
                        density="compact"
                        color="primary"
                        data-cy="is-receive-marketing-emails"
                    />
                </v-row>
                <div class="text-subtitle-1 font-italic py-4">{{ $t('clients_page.tags_note') }}</div>
                <h5 class="text-subtitle-1 pb-1">{{ $t('clients_page.offered_products_label') }}:</h5>
                <v-textarea
                    v-model="settings.requestedTags"
                    variant="outlined"
                    rows="2"
                    color="primary"
                    data-cy="requested-tags"
                />
                <h5 class="text-subtitle-1 pb-1">{{ $t('clients_page.not_offered_products_label') }}:</h5>
                <v-textarea
                    v-model="settings.excludedTags"
                    variant="outlined"
                    rows="2"
                    color="primary"
                    data-cy="excluded-tags"
                />
            </v-col>
        </v-row>
        <v-row class="px-4 py-4">
            <v-btn
                :loading="isLoading"
                :disabled="isLoading || !clientId"
                color="primary"
                class="mr-4"
                data-cy="save"
                @click="save"
            >
                {{ $t('save') }}
            </v-btn>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import type {ClientSettingsType} from '~/utils/types/account/clients/types'

    const initData = (): ClientSettingsType => ({
        receiveMarketingEmails: false,
        requestedTags: '',
        excludedTags: '',
    })

    @Component({})
    export class SettingsForm extends Vue {
        @Prop({required: true}) clientId: number

        isLoading: boolean = false
        settings: ClientSettingsType = initData()

        mounted() {
            this.initData()
        }

        async initData(): Promise<void> {
            try {
                this.settings = await this.$api.settings.get(this.clientId)
            } catch (e) {
                this.settings = initData()
            }
        }

        async save(): Promise<void> {
            this.isLoading = true
            try {
                await this.$api.settings.put(this.clientId, this.settings)
                this.$toast.success(this.$t('success_message.saved_successfully'))
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.isLoading = false
            }
        }
    }

    export default SettingsForm
</script>
